import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Analytics } from '../../../../common/interfaces';
import { LoginSignupService } from '../../../../services/login-signup.service';

@Component({
  selector: 'help-modal',
  templateUrl: 'help-modal.pug',
})
export class HelpModal implements OnInit {
  @Output() close = new EventEmitter<void>();
  constructor(public loginSignupService: LoginSignupService) {
  }
  ngOnInit() {
    this.loginSignupService.trackEvent(Analytics.OpenHelpModel);
  }
  closeModal() {
    this.close.emit();
  }
}
